import { Global, css } from "@emotion/react";
import React from "react";

const globalCss = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo",
      "Noto Sans KR", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: #222222;
    background: #f6f7f9;
    -webkit-font-smoothing: antialiased;
  }
  button {
    font-family: inherit;
    cursor: pointer;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  input,
  select,
  textarea {
    font-family: inherit;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const GlobalStyles = () => <Global styles={globalCss} />;
export default GlobalStyles;
